import {
    CLEAR_ATTACHMENTS,
    CLEAR_SCAN_ATTACHMENT_RESULT,
    COPY_ATTACHMENTS,
    COPYING_ATTACHMENTS,
    DELETE_ALL_LINE_ITEM_ATTACHMENTS,
    DELETE_ATTACHMENT,
    DELETE_COPYING_ATTACHMENTS,
    DELETE_UPLOADING_ATTACHMENT,
    SCAN_ATTACHMENT_RESULT,
    SCAN_ATTACHMENT_RESULT_COPY,
    SET_AMEND_REQ_ATTACHMENTS,
    SET_ATTACHMENT_LINE_ITEM,
    SET_ATTACHMENT_RECIPIENTS,
    SET_AUTH_CHECK_DIALOG,
    SET_AVAILABLE_ATTACHMENTS_TO_COPY,
    SET_DISABLE_COPY,
    SET_LEVEL_TYPE,
    SHOW_ATTACHMENT_COPY_DIALOG,
    SHOW_COPY_CONFIRM_DIALOG,
    TOGGLE_SELECTED_ATTACHMENTS_FOR_DELETION,
    UPDATE_AVAILABLE_ATTACHMENTS_TO_COPY,
    UPDATE_SCAN_RESULTS_STATUS,
    UPDATE_SELECTED_HEADER_ATTACHMENT_IDS,
    UPDATE_SELECTED_LINE_ATTACHMENT_IDS,
    UPLOADED_ATTACHMENT,
    UPLOADING_ATTACHMENT,
} from "../actionTypes";

export const uploadingAttachmentAction = (attachment_payload) => {
    return {
        type: UPLOADING_ATTACHMENT,
        payload: attachment_payload,
    };
};

export const deleteUploadingAttachmentAction = (uploadingId) => {
    return {
        type: DELETE_UPLOADING_ATTACHMENT,
        payload: { uploadingId },
    };
};

export const uploadedAttachmentAction = (attachment_payload) => {
    return {
        type: UPLOADED_ATTACHMENT,
        payload: attachment_payload,
    };
};

/**
 * This action method gets called when user copy the requisition and select Yes for attachments to copy
 * @param {Array} attachment_payload - List of attachment objects to be copied from the requisition
 * @returns
 */
export const setAvailableAttachmentsToCopyAction = (attachment_payload) => {
    return {
        type: SET_AVAILABLE_ATTACHMENTS_TO_COPY,
        payload: attachment_payload,
    };
};

/**
 *
 * Given properties gets updated in the attachment of given attachmentId's
 * @param {Array} attachmentIds - Array of attachment ids, example: ["abc124", "abce234"]
 * @param {Object} properties - Properties to update in the attachment object,
 * for example: I want to update isCopied= true and isSelectedToCopy=true for given attachment ids, need to supply object as below
 * {
 *   isCopied: true,
 *   isSelectedToCopy: true
 * }
 * @returns
 */
export const updateAvailableAttachmentsToCopyAction = (
    attachmentIds,
    properties
) => {
    return {
        type: UPDATE_AVAILABLE_ATTACHMENTS_TO_COPY,
        payload: { attachmentIds, properties },
    };
};

/**
 *
 * @param {Array} attachment_payload - Array of attachment objects
 * @returns
 */
export const copyingAttachmentAction = (attachment_payload) => {
    return {
        type: COPYING_ATTACHMENTS,
        payload: { attachments: attachment_payload },
    };
};

export const deleteCopyingAttachmentsAction = (attachment_payload) => {
    return {
        type: DELETE_COPYING_ATTACHMENTS,
        payload: { attachments: attachment_payload },
    };
};

export const scanAttachmentResult = (scan_payload) => {
    return {
        type: SCAN_ATTACHMENT_RESULT,
        payload: scan_payload,
    };
};

export const scanAttachmentResultCopy = (scan_payload) => {
    return {
        type: SCAN_ATTACHMENT_RESULT_COPY,
        payload: scan_payload,
    };
};

export const setAmendedReqAttachments = (attachmentsPayload) => {
    return {
        type: SET_AMEND_REQ_ATTACHMENTS,
        payload: attachmentsPayload,
    };
};

export const deleteAttachmentAction = (scan_payload) => {
    return {
        type: DELETE_ATTACHMENT,
        payload: scan_payload,
    };
};

export const deleteAllLineAttachmentsAction = (lineIndex) => {
    return {
        type: DELETE_ALL_LINE_ITEM_ATTACHMENTS,
        payload: lineIndex,
    };
};

export const copyAttachments = (results) => {
    return {
        type: COPY_ATTACHMENTS,
        payload: results,
    };
};

export const updateScanResultStatus = (results) => {
    return {
        type: UPDATE_SCAN_RESULTS_STATUS,
        payload: results,
    };
};

export const setDisableCopy = (data) => {
    return {
        type: SET_DISABLE_COPY,
        payload: data,
    };
};

export const openAuthCheckDialog = (openAuthDialog) => {
    return { type: SET_AUTH_CHECK_DIALOG, payload: openAuthDialog };
};

export const setShowCopyConfirmDialog = (setShow) => {
    return { type: SHOW_COPY_CONFIRM_DIALOG, payload: setShow };
};

export const setShowAttachmentCopyDialog = (setShow) => {
    return { type: SHOW_ATTACHMENT_COPY_DIALOG, payload: setShow };
};
export const clearScanAttachmentResult = () => {
    return { type: CLEAR_SCAN_ATTACHMENT_RESULT };
};

export const attachmentLineItem = (levelType, index) => {
    return {
        type: SET_ATTACHMENT_LINE_ITEM,
        payload: { levelType: levelType, index: index },
    };
};

export const setLevelType = (levelType) => {
    return {
        type: SET_LEVEL_TYPE,
        payload: levelType,
    };
};

export const clearAllAttachments = () => {
    return {
        type: CLEAR_ATTACHMENTS,
        payload: {},
    };
};

export const updateSelectedLineAttachments = (selectedLineAttachmentIds) => {
    return {
        type: UPDATE_SELECTED_LINE_ATTACHMENT_IDS,
        payload: selectedLineAttachmentIds,
    };
};

export const updateSelectedHeaderAttachments = (selectedAttachmentIds) => {
    return {
        type: UPDATE_SELECTED_HEADER_ATTACHMENT_IDS,
        payload: selectedAttachmentIds,
    };
};

export const toggleAttachmentsSelectionForDeletion = (
    attachmentIds,
    isSelected,
    isPostPOAmendment
) => {
    return {
        type: TOGGLE_SELECTED_ATTACHMENTS_FOR_DELETION,
        payload: { attachmentIds, isSelected, isPostPOAmendment },
    };
};

export const setAttachmentRecipients = (attachmentId, selectedRecipients) => {
    return {
        type: SET_ATTACHMENT_RECIPIENTS,
        payload: { attachmentId, selectedRecipients },
    };
};
